module.exports = __webpack_public_path__ + "img/志愿服务.1b4201e7.png";